import * as yup from "yup";

export const validationSchema = yup.object().shape({
  driverId: yup.string().required("Driver is required"),
  driverName: yup.string(),
  task: yup.string().required("Task is required"),
  startDate: yup.string().required("Start date is required"),
  endDate: yup.string().required("End date is required"),
  isImmediate: yup.boolean(),
  notes: yup.string(),
});